<template>
  <div class="container">
    <header class="header" v-if="showHeader">
      <div class="nes-container is-centered">
        <h2>VAA Community Track Manager</h2>
      </div>
    </header>
    <main class="content">
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
export default {
  name: 'App',
  data () {
    return {
      showHeader: true
    }
  },
  mounted() {
    if(this.$route.name === 'MeetView') {
      this.showHeader = false;
    }
  },
  methods: {
    
  },
  components: {
  }
}
</script>
<style>
    html,
    body,
    pre,
    code,
    kbd,
    samp {
      font-family: "Press Start 2P";
    }
    * {
      box-sizing: border-box;
    }

    body {
      background-color: white;
    }

  .container {
    display: flex;
    align-items: center;
    flex-direction: column;
  }
  .header {
    width: 1280px;
    color:#bc8b31;
  }

@media only screen and (min-device-width : 320px) and (max-device-width : 480px) {
/* Styles */
  .content {
    width: 100%;
  }
     
}
@media only screen  and (min-width : 1224px) {
/* Styles */
  .content {
    width: 1280px;
  }
      body {
      margin: 2em;
    }
}

</style>

